// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueComparison.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * OperatorValueComparison component
 */
!(function() {
  var m = require('mobx-react');
  var React = require('react');

  var OperatorValueInput = require('modules/OperatorValue/Izenda.OperatorValueInput');
  var OperatorValueTwoInput = require('modules/OperatorValue/Izenda.OperatorValueTwoInput');
  const { isNil, placeholder } = require('lodash/fp');
  /**
   * Get component render function
   * @param  {object} object Component object
   * @param  {string} key Operator filter key
   * @return {function} Render component function
   */
  function getComponentRender(object, key) {
    return placeholder(object).get(key);
  }

  /**
   * Datetime filter value
   * @type {Object}
   */
  var comparisonFilterComponents = {
    notbetween: {
      component: OperatorValueTwoInput
    },
    between: {
      component: OperatorValueTwoInput
    },
    notgreaterthan: {
      component: OperatorValueInput
    },
    notlessthan: {
      component: OperatorValueInput
    },
    isgreaterthan: {
      component: OperatorValueInput
    },
    islessthan: {
      component: OperatorValueInput
    }
  };

  /**
   * OperatorValueComparison description
   * @param {type} props description
   */
  var OperatorValueComparison = function(props) {
    var operator = props.filterInfo.operator || {};
    var key = operator.key;
    var componentInfo = getComponentRender(comparisonFilterComponents, key);

    if (isNil(componentInfo)) {
      return null;
    }

    return <componentInfo.component {...props} />;
  };

  module.exports = m.observer(OperatorValueComparison);
})();



// WEBPACK FOOTER //
// ./ui/modules/OperatorValue/Izenda.OperatorValueComparison.jsx